import Vue from 'vue';
const userapplications = {
  state: {
    userapplications: [],
    submitted: [
      {
        ID: 1,
        User: {FirstName: 'Jon', LastName: 'Doe'},
        PracticeSiteInformation: [
          {
            SiteAddress: {
              ID: 1, SiteInsitutionName: 'Curran Seeley Foundation', Address1: '610 W Broadway Ave Ste L-1', City:'Jackson', State: 'WY', Zip: '83001-8213', County: 'Teton'
            },
            IsPrimary: true
          }
        ],
        CreatedOn: new Date('09/15/2018')
      },
      {
        Id: 2,
        User: {FirstName: 'Jane', LastName: 'Smith'},
        PracticeSiteInformation: [
          {
            SiteAddress: {
              ID: 2, SiteInsitutionName: 'Bridger Valley Family Practice', Address1: '107 N Main St', City:'Lyman', State: 'WY', Zip: '82937', County: 'Uinta'
            },
            IsPrimary: true
          }
        ],
        CreatedOn: new Date('08/17/2018')
      }
    ],
    approved: [
      {
        Id: 2,
        User: {FirstName: 'Jane', LastName: 'Smith'},
        PracticeSiteInformation: [
          {
            SiteAddress: {
              ID: 2, SiteInsitutionName: 'Bridger Valley Family Practice', Address1: '107 N Main St', City:'Lyman', State: 'WY', Zip: '82937', County: 'Uinta'
            },
            IsPrimary: true
          }
        ],
        CreatedOn: new Date('08/17/2018')
      }
    ]
  },

  getters: {
    userapplications(state) {
      return state.userapplications;
    },
    submitted(state) {
      return state.submitted;
    },
    approved(state) {
      return state.approved;
    }
  },

  mutations: {
    getApplications(state, payload) {
      state.userapplications = payload;
    },
    getSubmitted(state, payload) {
      state.submitted = payload;
    },
    getApproved(state, payload) {
      state.approved = payload;
    },
  },

  actions: {
    getApplications(context, payload) {
      const url = `ApplicationByUserId/${ payload.Id  }`;
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getApplications', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },

    getApplicationsByID(context, payload) {
      const url = `ApplicationById/${ payload.Id }`;
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getApplications', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },

    getSubmitted(context, payload) {
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getSubmitted', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    getApproved(context, payload) {
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            context.commit('getApproved', res.data);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    updateApplications(context, payload){
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createApplications(context, payload){
      const url = `Applications`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteApplications(context, payload){
      const url = `Applications/${ payload.Id }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getApplications')
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default userapplications